<div class="flex justify-center items-center h-full">
    <div class="modalCodeWhatsapp py-6" style="width: 500px;">
      <!---Modal header-->
      <div class="headerModal flex" *ngIf="!flag_code_send">
        <p class="title">Confirmación</p>
        <button (click)="closeDialog(false)">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
      </div>

      <div class="headerModal flex" *ngIf="flag_code_send">
        <p class="title">Validación de código</p>
        <button (click)="closeDialog(false)">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
      </div>

      <!---Modal Body-->
      <div class="bodyModal px-6 pt-4">
        <div class="textBody" *ngIf="!flag_code_send">
          <p>{{'phone_use' | translate}}</p>
        </div>
        <form *ngIf="!flag_code_send" [formGroup]="form_phone">
            <div class="pb-7">
              <input
                type="text"
                id="phone"
                [formControlName]="'phone'"
                (keydown.space)="$event.preventDefault()"
                class="border text-gray-900 text-14px block w-full p-3"
                placeholder="123 234 234" />
            </div>

            <div *ngIf="!flag_progress && !flag_code_send" class="flex justify-end" style="gap: 1rem;">
              <button
                mat-stroked-button
                id="btnCancel"
                (click)="closeDialog(false)"
                class="font-semibold text-14px">
                {{ 'modalRefCodeCancel' | translate }}
              </button>
              
              <button
                mat-stroked-button
                id="btnAccept"
                (click)="send_code()"
                [disabled]="form_phone.invalid"
                class="font-semibold text-white text-14px">
                {{ loading ? ('loadingMessage' | translate) : ('validate' | translate)}}
              </button>
            </div>

            <div *ngIf="flag_progress && flag_code_send" class="flex justify-center space-x-4 " style="display: flex; justify-content:space-evenly">
                <button
                  mat-stroked-button
                  id="btnAccept"
                  (click)="closeDialog(true)"
                  [disabled]="form_code_verification.invalid"
                  class="font-semibold text-white text-14px">
                  {{ 'progress' | translate }}
                </button>
            </div>
        </form>

        <div class="textBody" *ngIf="flag_code_send">
          <p>{{ 'code_whatsapp' | translate }}</p>
        </div>
        <form *ngIf="flag_code_send" [formGroup]="form_code_verification">
          <div class="">
            <input *ngIf="!flag_progress"
              type="text"
              id="code"
              [formControlName]="'code'"
              (keydown.space)="$event.preventDefault()"
              class="border text-gray-900 text-14px block w-full p-3 mb-3"
              placeholder="Escribe un código" />

            <div *ngIf="flag_error_code" class="errorCode flex items-center text-14px">
              <mat-icon class="material-symbols-outlined mr-1">error_outline</mat-icon> {{ text_error }}
            </div>
          </div>
  
          <div *ngIf="!flag_progress && flag_code_send" class="flex justify-end pt-7" style="gap: 1rem;">
            <button
              mat-stroked-button
              id="btnCancel"
              (click)="closeDialog(false)"
              class="font-semibold text-14px">
              {{ 'modalRefCodeCancel' | translate }}
            </button>

            <button
              mat-stroked-button
              id="btnAccept"
              (click)="validate_code()"
              [disabled]="form_code_verification.invalid"
              class="font-semibold text-white text-14px">
              {{ loading ? ('loadingMessage' | translate) : ('validate' | translate)}}
            </button>
          </div>
  
          <div>
              <div *ngIf="flag_progress && flag_code_send" class="textBody pb-7">
                  <div class="">
                      {{ 'code_ok' | translate }}
                  </div>    
              </div>
  
              <div *ngIf="flag_progress && flag_code_send" class="flex justify-center space-x-4">
                  <div class="flex justify-end" style="gap: 1rem;">
                      <button
                        mat-stroked-button
                        id="btnCancel"
                        (click)="closeDialog(false)"
                        class="font-semibold text-14px">
                        {{ 'modalRefCodeCancel' | translate }}
                      </button>

                      <button
                          mat-stroked-button
                          id="btnAccept"
                          (click)="closeDialog(true)"
                          class="font-semibold text-white text-14px">
                          Continuar
                      </button>
                  </div>
              </div>
          </div>    
        </form>
      </div>
    </div>
  </div>
